import { TimeRange } from '@nirvana/shared/dtos/types/shared/time';

export enum Column {
  CATEGORY = 0,
  DETAILS = 1,
  COMMAND_LINE = 2,
  ACTION_TAKEN = 3,
  THREAT_TYPE = 4,
  DEVICE_NAME = 5,
  IP = 6,
  ENDPOINT_TYPE = 7,
  LAST_DETECTED = 8,
  USER = 9,
  DETECTING_MODULE = 10,
  DETECTING_TECHNOLOGY = 11,
  MALWARE_NAME = 12,
  FILELESS_ATTACK = 13,
  INSERTED_AT = 14,
  HOST_NAME = 15,
  SHA_256 = 16,
  COMPANY = 17,
  MODULES = 18,
  SOURCE = 19,
  TAGS = 20,
}

export enum EndpointType {
  WORKSTATION = 0,
  SERVER = 1,
  CONTAINER_HOST = 2,
  CONTAINER = 3,
}

export interface Regex {
  pattern: string;
  options?: string;
}

export interface StringConditions {
  equals?: string;
  in?: Array<string>;
  contains?: string;
  regex?: Regex;
  startsWith?: string;
}

export interface IntConditions {
  equals?: number;
  in?: Array<number>;
  greaterThan?: number;
  lowerThan?: number;
  greaterThanOrEqual?: number;
  lowerThanOrEqual?: number;
}

export interface DoubleConditions {
  equals?: number;
  in?: Array<number>;
  greaterThan?: number;
  lowerThan?: number;
  greaterThanOrEqual?: number;
  lowerThanOrEqual?: number;
}

export interface DateConditions {
  timeRange?: TimeRange;
}

export interface IntEnumConditions {
  in: Array<number>;
}

export type AllFilterTypeConditions =
  | StringConditions
  | IntConditions
  | DoubleConditions
  | DateConditions
  | IntEnumConditions;

export interface Filter {
  lastDetectedOn?: DateConditions;
  insertedAt?: DateConditions;
  category?: IntEnumConditions;
  actionTaken?: IntEnumConditions;
  deviceName?: StringConditions;
  details?: StringConditions;
  commandLine?: StringConditions;
  threatType?: IntEnumConditions;
  ip?: StringConditions;
  endpointType?: IntEnumConditions;
  user?: StringConditions;
  detectingModule?: IntEnumConditions;
  detectingTechnology?: IntEnumConditions;
  malwareName?: StringConditions;
  sha256?: StringConditions;
  filelessAttack?: IntEnumConditions;
  hostName?: StringConditions;
  company?: StringConditions;
  tags?: StringConditions;
}

export enum CompanySpecialValues {
  ALL = 'all',
  ALL_DIRECT_MANAGEMENT = 'allDirectManagement',
}

export enum EndpointSpecialValues {
  ALL = 'all',
}

export enum TagsSpecialValues {
  NO_TAGS_ASSIGNED = '-100',
}
